module.exports = new __parcel__URL__("add-icon.ca837662.svg").toString();